import React, { Component, forwardRef } from "react";
import PropTypes from "prop-types";
import { LuUpload } from "react-icons/lu";
import FileInput from "../../../../common/file-input/FileInput";

/**
 * Upload dropzone: a large click/drop target (styled in
 * sass/events/_draganddrop.scss — .uploadDropzone). With `multiple` the
 * callback receives an ARRAY of files; without it, a single file (legacy
 * contract).
 */
class ExternalDropzoneInner extends Component {
  constructor(props) {
    super(props);
    this.onDrop = this.onDrop.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  onDrop(event) {
    const files = Array.from(event.target.files || []);
    if (files.length === 0) return;
    if (!this.props.callback) return;
    if (this.props.multiple) {
      this.props.callback(files);
    } else {
      this.props.callback(files[0]);
    }
    // Same file can be picked again right after (clearing a queued row).
    if (event.target && event.target.value !== undefined) event.target.value = "";
  }

  handleClick() {
    // Explicitly trigger the underlying file input when the drop area is clicked.
    const input = this.props.forwardedRef && this.props.forwardedRef.current;
    if (input && typeof input.click === "function") {
      input.click();
    }
  }

  render() {
    return (
      <FileInput
        ref={this.props.forwardedRef}
        onChange={this.onDrop}
        className="fileInput uploadDropzoneWrap"
        accept={this.props.accept}
        multiple={this.props.multiple}
        style={{ display: "block", width: "100%" }}
      >
        <div className="uploadDropzone" onClick={this.handleClick}>
          <span className="uploadDropzone-icon">
            <LuUpload size={26} aria-hidden="true" />
          </span>
          <b className="uploadDropzone-title">
            {IdealStudio.i18n.t(
              this.props.multiple ? "FileInput.MessageMulti" : "FileInput.Message"
            )}
          </b>
          <span className="uploadDropzone-hint">{IdealStudio.i18n.t("FileInput.ClickHint")}</span>
        </div>
      </FileInput>
    );
  }
}

ExternalDropzoneInner.propTypes = {
  /**
   * Mimetype accepted
   * */
  accept: PropTypes.any,
  /**
   * Called with a single File (default) or a File[] when `multiple`
   */
  callback: PropTypes.func,
  /**
   * Allow selecting/dropping multiple files
   */
  multiple: PropTypes.bool,
  /**
   * Forwarded ref
   */
  forwardedRef: PropTypes.any,
};

// Export the component wrapped with forwardRef to handle React 19 ref compatibility
const ExternalDropzone = forwardRef((props, ref) => (
  <ExternalDropzoneInner {...props} forwardedRef={ref} />
));

export default ExternalDropzone;
